export const COGNITO = {
  REGION: "us-east-1",
  USER_POOL_ID: "us-east-1_g2JypYl6q",
  APP_CLIENT_ID: "2q2pijpp0nbr4e3agnv33l02f2",
};
